import { MaskitoOptions, maskitoUpdateElement } from '@maskito/core';
import { maskitoCaretGuard, maskitoEventHandler, maskitoNumberOptionsGenerator } from '@maskito/kit';

export class Mask {
  // Дефолтное количество знаков после разделителя
  private static _defaultFractionalCount = 2;

  /**
   * Mask email string
   * @param {string} value
   * @param {string} replace
   * @return {number}
   */
  public static email(value: string, replace = '*'): string {
    if (!value || value.length === 0) {
      return value;
    }

    const at = value.lastIndexOf('@');
    const start = at < 5 ? 0 : 1;
    const diff = at < 3 ? at : at < 5 ? at - 2 : 3;

    return value.substring(0, start) + replace.repeat(at - diff) + value.substring(at + start - diff);
  }

  /**
   * Mask phone number string
   * @param {string} value
   * @param {string} replace
   * @return {string}
   */
  public static phone(value: string, replace = '*'): string {
    if (!value || value.length === 0) {
      return value;
    }

    const last = value.length - 4;
    const diff = last > 6 ? 5 : 1;

    return value.substring(0, 3) + replace.repeat(last - diff + 1) + value.substring(last);
  }

  public static getDecimalPlacesMask(precision: number = this._defaultFractionalCount, thousandSeparator = ''): Required<MaskitoOptions> {
    return maskitoNumberOptionsGenerator({ precision, thousandSeparator });
  }

  public static getPercentMask(precision: number = this._defaultFractionalCount): Required<MaskitoOptions> {
    const postfix = '%';

    const { plugins, ...numberOptions } = maskitoNumberOptionsGenerator({
      precision,
      postfix,
      max: 100,
      min: 0,
    });

    return {
      ...numberOptions,
      plugins: [
        ...plugins,
        maskitoCaretGuard((value) => [0, value.length - 1]),
        maskitoEventHandler('blur', (element) => {
          if (element.value === postfix) {
            maskitoUpdateElement(element, `0${postfix}`);
          }
        }),
      ],
    };
  }

  public static getIntegerPercentMask(): Required<MaskitoOptions> {
    return this.getPercentMask(0);
  }

  public static disabled(): MaskitoOptions {
    return { mask: [] };
  }
}
